// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1oP-F","inputWrap":"styles_inputWrap__17h2C","input":"styles_input__bPgtD"};